import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	initialized: false,
	callLogs: [],
	timeEntries: [],
	users: [],
	organizations: [],
	teams: [],
	teamType: '',
	trackingData: [],
	searchQuery: {_page: 1},
};
